import React from 'react';
import LeftPanel from "./LeftPanel";
import RightPanel from "./RightPanel";

const SubAdminFullLayout = ({backgroundImage, children}) => {
    return (
        <section className='sub-admin-full-layout'>
            <div className='d-flex'>
                <LeftPanel 
                    backgroundImage={backgroundImage}
                />
                
                <RightPanel 
                    children={children}
                />
            </div>
        </section>
    )
}

export default SubAdminFullLayout